import React from "react";
import { FieldProps } from "react-jsonschema-form";
import styled from "styled-components";

const StyledSection = styled.h5`
  margin-bottom: 20px;
`;

export default function Section({ schema, ...rest }: FieldProps) {
  return <StyledSection>{schema.title}</StyledSection>;
}
